export default __webpack_public_path__ + "static/media/gamestack-login.256da710.jpg";